module.exports = __webpack_public_path__ + "img/home.278345ab.png";